import ITableRow from "../models/ITableRow";
import ICsvData from "../models/ICsvData";
import IBullData from "../models/IBullData";

export enum ActionType {
  FetchCalculatedTableRows = "Fetch_CALCULATED_TABLE_ROWS",
  ReceiveCalculatedTableRows = "RECEIVE_CALCULATED_TABLE_ROWS",
  ReceiveCalculatedTableError = "RECEIVE_CALCULATED_TABLE_ROWS_ERROR",
}

/*
 * Define return types of our actions
 * Every action returns a type and a payload
 */
export interface IFetchCalculatedTableRowsAction {
  type: ActionType.FetchCalculatedTableRows;
}

export interface IReceiveCalculatedTableRowsAction {
  type: ActionType.ReceiveCalculatedTableRows;
  payload: ITableRow[];
}

export interface IReceiveCalculatedTableRowsErrorAction {
  type: ActionType.ReceiveCalculatedTableError;
}

/*
 * Define our actions creators
 * We are returning the right Action for each function
 */
export function fetchCalculatedTableRows(
  csvData: ICsvData[],
  selectedBulls: IBullData[]
): (dispatch: (actions: Action) => void, getState: () => any) => void {
  // make an API request to S3
  return async (dispatch) => {
    dispatch({
      type: ActionType.FetchCalculatedTableRows,
    });
    const cows = csvData.map((cow) => ({
      cow: cow.cowNumber,
      cowSire: cow.sire,
      cowMaternalGrandSire: cow.grandSire,
    }));
    const bullIds = selectedBulls.map((bull) => bull.ABCode);

    // eslint-disable-next-line max-len
    const inBreedingCoefficientLambdaUrl =
      "https://344npn8api.execute-api.ap-southeast-2.amazonaws.com/default/InbreedingCoefficientPercentage";
    const data = await fetch(inBreedingCoefficientLambdaUrl, {
      body: JSON.stringify({ cows, bullIds }), // must match 'Content-Type' header
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, same-origin, *omit
      headers: {
        "content-type": "application/json",
      },
      method: "POST",
      mode: "cors",
      redirect: "follow",
      referrer: "no-referrer",
    }).then((response) => response.json());
    const payload = JSON.parse(data.body);
    // in the next few lines we have to preserve the order of  the returned items as these map directly to the table
    // TODO Add tests
    const tableRows = payload.map((cowData: any, index: number) => ({
      "Cow number/ name": cowData.cow,
      "Cow Sire": cowData.cowSire,
      "Maternal Grandsire": cowData.cowMaternalGrandSire,
      Issues: cowData.issues
        ? csvData[index].messages.concat([cowData.issues])
        : csvData[index].messages,
      ...cowData.inbreedingCoefficientValues,
    }));
    dispatch({
      type: ActionType.ReceiveCalculatedTableRows,
      payload: tableRows,
    });
  };
}

export type Action =
  | IFetchCalculatedTableRowsAction
  | IReceiveCalculatedTableRowsAction
  | IReceiveCalculatedTableRowsErrorAction;



// WEBPACK FOOTER //
// ./src/scripts/actions/TableActions.ts